export enum IOrderFields {
    Name = 'Name',
    Visibility = 'Visibility',
}

export interface IDeleteUserForm {
    occurrenceTypeId?: number;
}
